import axios from 'axios';
import {clearStorage, getStorage, getToken} from '../utils/auth';
import router from '../router';
import { Notification } from 'element-ui';
import store from '@/store';
import Vue from "vue";

// 动态获取基础 URL
const base_url = process.env.VUE_APP_URL || 'https://cirapi.zhuoshangsoft.com';

const service = axios.create({
    baseURL: base_url,
    timeout: 30000
});

// 请求拦截器
service.interceptors.request.use((config) => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    const params = new URLSearchParams(config.data || '');
    const dynamicParams = {
        version: process.env.VUE_APP_VERSION,
        timezone: getStorage('timezone') || 8,
        language: store.getters.language,
        token: getToken(),
        host: process.env.NODE_ENV === 'development' ? 'localhost:9527' : window.location.host
    };

    Object.entries(dynamicParams).forEach(([key, value]) => {
        params.append(key, typeof value === 'string' ? value.trim() : value);
    });

    config.data = params.toString();
    return config;
}, (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
});

// 响应拦截器
let errorTimer = null;
service.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (!error.response) {
            showError('网络连接异常');
            return Promise.reject(error);
        }

        const { status } = error.response;
        switch (status) {
            case 401: handleUnauthorized(); break;
            case 403: showError('无权访问', { once: true }); break;
            // 提示版本更新
            case 426: upgradeRequiredHttpException(); break
            default: showError(`请求失败 (${status})`);
        }

        return Promise.reject(error);
    }
);

// 426 处理函数
let time426 = 0
let timer426 = null
function upgradeRequiredHttpException() {
    console.log('==upgradeRequiredHttpException==', time426)
    if (time426 == 0) {
        showError('请刷新更新到最新版本')
        time426 = 1
        timer426 = setTimeout(() => {
            timer426 = 0
            clearTimeout(timer426)
            timer426 = null
        }, 3000)
    }
}

// 封装错误提示函数
function showError(message, options = {}) {
    if (options.once && errorTimer) return;
    Notification.warning(message)
    // Message({
    //     message,
    //     type: 'warning',
    //     offset: 360
    // });

    if (options.once) {
        errorTimer = setTimeout(() => {
            errorTimer = null;
        }, 2000);
    }
}

// 401 处理函数
function handleUnauthorized() {
    if (getToken()) {
        showError('登录超时');
        Vue.prototype.$EventBus.$emit('exitIM')
        clearStorage()
        localStorage.clear()
        router.push('/login');
    }
}

// 导出
export const axiosInstance = service;
export default {
    install(Vue) {
        Vue.prototype.$axios = service;
        Vue.prototype.$updateApiBaseUrl = (url) => service.defaults.baseURL = url;
    }
};
